import { useEffect } from "react";

const SITE_URL = "https://valubi.dk";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, name] = selector.match(/meta\[([\w-]+)="([^"]+)"\]/) || [];
    if (key && name) el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

/**
 * Updates document head metadata (title, description, canonical, OG, Twitter, JSON-LD)
 * directly via DOM. Static tags in index.html serve as fallback for crawlers
 * that don't execute JS; this hook updates them per route.
 */
const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  ogType = "website",
  jsonLd,
  noindex = false
}) => {
  const url = `${SITE_URL}${path}`;

  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", url);

    setMeta('meta[property="og:type"]', "content", ogType);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[property="og:locale"]', "content", "da_DK");
    setMeta('meta[property="og:site_name"]', "content", "Valubi");

    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", image);

    setJsonLd("page-jsonld", jsonLd);
  }, [title, description, url, image, ogType, jsonLd, noindex]);

  return null;
};

export default SEO;
